import * as S from './styles'
export const TituloContato = () => {
    return (
        <S.Container>
            <h3>NOSSOS MEIOS DE CONTATO</h3>
            <div className='hr' />
        </S.Container>
    )
}